<ng-template [ngIf]="loaded" [ngIfElse]="loading" >
        <div class="row justify-content-center">
        
          <div class="col-8">
            <div class="row  justify-content-center">
              <h2 class="col-12 titleBookk bold margin-block">{{ 'EDITPASSWORD.TITLE' | translate }}</h2>
              <mat-card class="col-12 ">
                <div class="row justify-content-center">
                  <div class="col-12 ">
                    <div class="row justify-content-center">
                      <div class="col-12  col-md-4">
                        <div class="round-img">
                          <img *ngIf="currentUser.profile_picture !== null" class="img-fluid" [src]="getUserImg()">
                    <img *ngIf="currentUser.profile_picture === null" class="img-fluid" src="../assets/img/Picto_Global/profil.jpg" alt="">
                        </div>
                      </div>
                      <div class="col-12 col-md-4">
                        <h3 class="col-12 light-font" style="
                              margin: 45px;
                              text-align: left !important;
                          ">{{currentUser.name}}</h3>
                      </div>
                    </div>
                  </div>
        
                  <h4 class="col-12 bold margin-block">{{ 'EDITPASSWORD.INFOCONNEXION' | translate }} : </h4>
                  <!-- <h4 class="col-12 ">{{currentUser.birthdate}}</h4> -->
                  <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                    {{ 'EDITPASSWORD.USERNAME' | translate }} :
                  </h5>
                  <h5 class="col-12 col-sm-6" style="text-align: left !important">
                    {{currentUser.name}}
                  </h5>
        
                  <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                    {{ 'EDITPASSWORD.PASSWORD' | translate }} :
                  </h5>
                  <div class="col-12 col-sm-6" style="text-align: left !important">
                        <input class="col-11" type="password" [(ngModel)]="currentPassword">
                </div>
                <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                  {{ 'EDITPASSWORD.NEWPASSWORD' | translate }} :
                      </h5>
                      <div class="col-12 col-sm-6" style="text-align: left !important">
                            <input class="col-11" type="password" [(ngModel)]="newPassword">
                    </div>
                    <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                      {{ 'EDITPASSWORD.VALIDEPASSWORD' | translate }} :
                          </h5>
                          <div class="col-12 col-sm-6" style="text-align: left !important">
                                <input class="col-11" type="password" [(ngModel)]="verifPassword">
                        </div>
                        <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                          {{ 'EDITPASSWORD.EMAIL' | translate }} :
                  </h5>
                  <h5 class="col-12 col-sm-6" style="text-align: left !important">
                    {{currentUser.email}}
                  </h5>
                  <div class="col-12 ">
                        <div class="row justify-content-end">
                          <div class="col-md-2 col-8">
                              <button class="full-width" (click)='ChangePassword();' mat-stroked-button color="primary">{{ 'EDITPASSWORD.BOUTONMODIFIER' | translate }}</button>
                          </div>
                        </div>
                      </div>
                </div>
              </mat-card>
        
              <mat-card class="col-12 col-md-12  margin-block">
                <div class="row">
                  <h3 class="col-12 bold margin-block ">{{ 'EDITPASSWORD.INFOPERSONNELLE' | translate }}</h3>
                  <div class="col-12 col-md-6 margin-block-s  hrline">
                    <div class="row ">
                      <h5 class="col-12 col-sm-12 bolder text-sm-center  text-center clem-green-font" >
                        {{ 'EDITPASSWORD.ETATCIVIL' | translate }} :
                      </h5>
                      <!-- <h5 class="col-12 col-sm-6" style="text-align: right !important"> -->
                      <!-- </h5> -->
                      <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                        {{ 'EDITPASSWORD.NOM' | translate }} :
                      </h5>
                      <h5 class="col-12 col-sm-6" style="text-align: left !important">
                        {{currentUser.lastname}}
                      </h5>
                      <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                        {{ 'EDITPASSWORD.PRENOM' | translate }} :
                      </h5>
                      <h5 class="col-12 col-sm-6" style="text-align: left !important">
                        {{currentUser.firstname}}
                      </h5>
        
                      <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                        {{ 'EDITPASSWORD.NAISSANCE' | translate }} :
                      </h5>
                      <h5 class="col-12 col-sm-6" style="text-align: left !important">
                        {{currentUser.birthdate}}
                      </h5>
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="row">
                      <h5 class="col-12 col-sm-12 bolder text-sm-center  text-center clem-green-font" >
                        {{ 'EDITPASSWORD.VOSINFORMATIONS' | translate }} :
                      </h5>
                  
                      <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                        {{ 'EDITPASSWORD.TEL' | translate }} :
                      </h5>
                      <h5 class="col-12 col-sm-6" style="text-align: left !important">
                        {{currentUser.phonenumber}}
                      </h5>
                      <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                        {{ 'EDITPASSWORD.EMAIL2' | translate }} :
                      </h5>
                      <h5 class="col-12 col-sm-6" style="text-align: left !important">
                        {{currentUser.email}}
                      </h5>
                      <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                        {{ 'EDITPASSWORD.COMMUNITY' | translate }} :
                      </h5>
                      <h5 class="col-12 col-sm-6" style="text-align: left !important">
                        {{currentUser?.community?.name}}
                      </h5>
        
                      <h5 class="col-12 col-sm-6 bolder text-sm-right  text-left">
                        {{ 'EDITPASSWORD.RFID' | translate }} :
                      </h5>
                      <h5 class="col-12 col-sm-6" style="text-align: left !important">
                        {{currentUser.rfid}}
                      </h5>
        
                    </div>
                  </div>
        
                </div>
        
        
                <div class="col-12 ">
                  <div class="row justify-content-end">
                    <div class="col-md-2 col-8">
                      <a routerLink="/user-edit" routerLinkActive="active">
                        <button class="full-width" mat-stroked-button color="primary">{{ 'EDITPASSWORD.BOUTONMODIFIER' | translate }}</button>
                      </a>
        
                    </div>
                  </div>
                </div>
        
              </mat-card>

              
              <mat-card class="col-12  margin-block ">
                <div class="row">
                  <div class="col" style="text-align: center">
                    <mat-icon svgIcon="autopartage" style="height: 75px; width: 75px; text-align: center;"></mat-icon>
                    <h4>{{ 'EDITPASSWORD.AUTOPARTAGE' | translate }}</h4>
        
                    <div *ngIf="currentUser.autopartage; else NoAutopargeBlock">
                      <div *ngIf="currentUser.permis; else NoPermisBlock">
                        <mat-icon style="color: green; height: 40px; width: 40px; text-align: center;">check</mat-icon>
                      </div>
                      <ng-template #NoPermisBlock>
                        <mat-icon style="color: orange ; height: 40px; width: 40px; text-align: center;"
                          matTooltip="Permis non validé">warning</mat-icon>
                      </ng-template>
                    </div>
                    <ng-template #NoAutopargeBlock>
                      <mat-icon style="color: red ; height: 40px; width: 40px; text-align: center;"
                        matTooltip="service non selectionné">cancel</mat-icon>
                    </ng-template>
                  </div>
        
                  <div class="col" style="text-align: center">
                    <mat-icon svgIcon="recharge" style="height: 75px; width: 75px; text-align: center;"></mat-icon>
                    <h4>{{ 'EDITPASSWORD.RECHARGE' | translate }}</h4>
        
                    <div *ngIf="currentUser.recharge; else NoAutopargeBlock">
                      <mat-icon style="color: green">check</mat-icon>
                    </div>
                    <ng-template #NoAutopargeBlock>
                      <mat-icon style="color: red " matTooltip="service non selectionné">cancel</mat-icon>
                    </ng-template>
                  </div>
                  <div class="col" style="text-align: center">
                    <mat-icon svgIcon="partage-trajet" style="height: 75px; width: 75px; text-align: center;"></mat-icon>
                    <h4>{{ 'EDITPASSWORD.PARTAGETRAJET' | translate }}</h4>
        
                    <div *ngIf="currentUser.partage_trajet; else NoAutopargeBlock">
                      <mat-icon style="color: green">check</mat-icon>
                    </div>
                    <ng-template #NoAutopargeBlock>
                      <mat-icon style="color: red" matTooltip="service non selectionné">cancel</mat-icon>
                    </ng-template>
                  </div>
                </div>
        
                <!-- <div class="col-12">
                  <div class="row justify-content-center">
                    <table class="col-12">
                      <tr>
                        <th>
                          <mat-icon svgIcon="autopartage" style="height: 40px;"></mat-icon>
                        </th>
                        <th>
                          <mat-icon svgIcon="recharge"></mat-icon>
                        </th>
                        <th>
                          <mat-icon svgIcon="partage-trajet"></mat-icon>
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <div *ngIf="currentUser.autopartage; else NoAutopargeBlock">
                            <div *ngIf="currentUser.permis; else NoPermisBlock">
                              <mat-icon style="color: green">check</mat-icon>
                            </div>
                            <ng-template #NoPermisBlock>
                              <mat-icon style="color: orange" matTooltip="Permis non validé">warning</mat-icon>
                            </ng-template>
                          </div>
                          <ng-template #NoAutopargeBlock>
                            <mat-icon style="color: red" matTooltip="service non selectionné">cancel</mat-icon>
                          </ng-template>
                        </td>
                        <td>
                          <div *ngIf="currentUser.recharge; else NoAutopargeBlock">
                            <mat-icon style="color: green">check</mat-icon>
                          </div>
                          <ng-template #NoAutopargeBlock>
                            <mat-icon style="color: red " matTooltip="service non selectionné">cancel</mat-icon>
                          </ng-template>
                        </td>
                        <td>
                          <div *ngIf="currentUser.partage_trajet; else NoAutopargeBlock">
                            <mat-icon style="color: green">check</mat-icon>
                          </div>
                          <ng-template #NoAutopargeBlock>
                            <mat-icon style="color: red" matTooltip="service non selectionné">cancel</mat-icon>
                          </ng-template>
                        </td>
                      </tr>
                    </table>
                     <table class="col-12">
                      <tr>
                        <th>
                          Permis
                        </th>
                        <th>
                          Caution
                        </th>
                      </tr>
                      <tr>
                        <td>
                          <div *ngIf="currentUser.permis; else NoPermisBlock">
                            <mat-icon style="color: green">check</mat-icon>
                          </div>
                          <ng-template #NoPermisBlock>
                            <mat-icon style="color: orange" matTooltip="Permis non validé">warning</mat-icon>
                          </ng-template>
                        </td>
                        <td>
                          <div *ngIf="currentUser.caution; else NoCaution">
                            <mat-icon style="color: green">check</mat-icon>
                          </div>
                          <ng-template #NoCaution>
                            <mat-icon style="color: red " matTooltip="Caution non validé">cancel</mat-icon>
                          </ng-template>
                        </td>
                      </tr>
                    </table> -->
                <!-- </div>
                </div> -->
              </mat-card>
        
              <!-- <mat-card class="col-12  margin-block">
                <h3>Mon permis de conduire</h3>
                <div class="col-12">
                  <div class="row justify-content-center">
                    <div class="col-10">
                      Numéro de délivrance : 123
                    </div>
                    <div class="col-10">
                      Date de délivrance : DD//MM/YYYY
                    </div>
                    <div class="col-10">
                      Ville de délivrance : [VILLE]
                    </div>
                    <div class="col-10">
                      Photocopie :
                      <div>
                        <img src="assets/img/Picto_Global/logoclem.png" alt="clem">
                      </div>
                    </div>
        
                  </div>
                </div>
              </mat-card> -->
        
            </div>
          </div>
        </div>
        </ng-template>
        <ng-template #loading>
            <div class="row">
                <!-- loading... -->
            </div>
        </ng-template>